export default __webpack_public_path__ + "static/media/datapower-monitoring.52d64f2e.svg";